<template>
  <div>
    <div class="targetingItem">
      <p
        class="baseName"
        v-if="!isNotMix(nameList)"
      >
        <span class="lebel">名称：</span>
        <span>
          <el-button
            type="text"
            size="mini"
            @click="nameMixShow = true"
            >混合值查看及编辑</el-button
          >
        </span>
      </p>
      <el-row v-if="isNotMix(nameList)">
        <el-col :span="20">
          <name
            :label-width="labelWidth"
            :nameInfo="nameMsg"
            @getNameMsg="getNameMsg"
          ></name>
        </el-col>
        <el-col
          :span="2"
          v-if="currentSelect.length > 1"
          ><el-button
            type="text"
            size="mini"
            @click="nameMixShow = true"
            class="mixBtn"
            >混合值查看及编辑</el-button
          ></el-col
        >
      </el-row>
    </div>
    <div
      class="targetingItem"
      v-if="!show_mood"
    >
      <p
        class="baseName"
        v-if="!isNotMix(postIdList)"
      >
        <span class="lebel">帖子Id：</span>
        <span>
          <el-button
            type="text"
            size="mini"
            @click="postIdMixShow = true"
            >混合值查看及编辑</el-button
          >
        </span>
      </p>
      <el-row v-if="isNotMix(postIdList)">
        <el-col :span="20">
          <post-id
            :label-width="labelWidth"
            :postIdInfo="postIdMsg"
          ></post-id>
        </el-col>
        <el-col
          :span="2"
          v-if="currentSelect.length > 1"
          ><el-button
            type="text"
            size="mini"
            @click="postIdMixShow = true"
            class="mixBtn"
            >混合值查看及编辑</el-button
          ></el-col
        >
      </el-row>
    </div>
    <div class="targetingItem">
      <p
        class="baseName"
        v-if="!isNotMix(statusList)"
      >
        <span class="lebel">状态：</span>
        <span>
          <el-button
            type="text"
            size="mini"
            @click="statusMixShow = true"
            >混合值查看及编辑</el-button
          >
        </span>
      </p>
      <el-row v-if="isNotMix(statusList) && !edit">
        <el-col :span="20">
          <status
            :label-width="labelWidth"
            :statusInfo="statusMsg"
            @getStatusMsg="getStatusMsg"
          ></status>
        </el-col>
        <el-col
          :span="2"
          v-if="currentSelect.length > 1"
          ><el-button
            type="text"
            size="mini"
            @click="statusMixShow = true"
            class="mixBtn"
            >混合值查看及编辑</el-button
          ></el-col
        >
      </el-row>
    </div>
    <div class="targetingItem">
      <p
        class="baseName"
        v-if="!isNotMix(pageMsgList)"
      >
        <span class="lebel">主页：</span>
        <span>
          <el-button
            type="text"
            size="mini"
            @click="pageMixShow = true"
            >混合值编辑</el-button
          >
        </span>
      </p>
      <el-row v-if="isNotMix(pageMsgList)">
        <el-col :span="20">
          <page
            :label-width="labelWidth"
            :pageList="pageList"
            :pageInfo="pageMsg"
            @getPageMsg="getPageMsg"
            @getPages="getPages"
            :loadPages="loadPages"
            :objective="objective"
            :account="account"
            :targetUserId="targetUserId"
          ></page>
        </el-col>
        <!-- <el-col :span="2" v-if="currentSelect.length>1"><el-button type="text" size="mini"  @click="pageMixShow = true" class="mixBtn">混合值查看及编辑</el-button></el-col> -->
      </el-row>
    </div>
    <div class="targetingItem">
      <p class="baseName">
        <span class="lebel">广告样式：</span>
        <span>
          <el-button
            type="text"
            size="mini"
            @click="adTypeMixShow = true"
            >{{ isCatalogAd ? '编辑目录广告格式' : (currentSelect.length > 1 ? '编辑混合值' : '编辑创意类型') }}</el-button
          >
          <el-button
            v-if="!isCatalogAd"
            type="text"
            size="mini"
            @click="setBaseData('adType')"
            >撤销修改</el-button
          >
        </span>
      </p>
    </div>
    <div
      class="targetingItem"
      v-if="!adTypesHasAssetFeed && !isAdvancedCreative"
    >
      <!-- 混合值时显示按钮 -->
      <p
        class="baseName"
        v-if="!isNotMix(messageList)"
      >
        <span class="lebel">正文：</span>
        <span>
          <el-button
            type="text"
            size="mini"
            @click="messageMixShow = true"
            >编辑混合值</el-button
          >
          <el-button
            type="text"
            size="mini"
            @click="setBaseData('message')"
            >恢复初始值</el-button
          >
        </span>
      </p>
      <!-- 非混合值时显示编辑器 -->
      <el-row v-if="isNotMix(messageList)">
        <el-col :span="20">
          <el-form label-width="140px">
            <el-form-item label="广告正文：">
              <message-editor
                :value="messageArray"
                @change="onMessageChange"
                placeholder="正文：介绍广告内容"
              >
                <template #extra>
                  <el-tooltip
                    :disabled="!isMultipleSelected"
                    content="选择多条数据时不支持AI推荐文案"
                    placement="top"
                  >
                    <span style="margin-left: 10px">
                      <el-tooltip
                        effect="dark"
                        placement="top"
                      >
                        <div slot="content">
                          目前仅支持中文、英语、葡萄牙语、西班牙语 <br />
                          官方说明文档：<a
                            href="https://www.facebook.com/business/help/497610041230617?locale=zh_CN"
                            target="_blank"
                            style="color: #409eff"
                            >https://www.facebook.com/business/help/497610041230617?locale=zh_CN</a
                          >
                        </div>
                        <el-button
                          type="text"
                          size="small"
                          @click="handleGenerateAiText"
                          :disabled="aiGenerateStatus === 'generating' || isMultipleSelected"
                        >
                          智能文案推荐
                        </el-button>
                      </el-tooltip>
                    </span>
                  </el-tooltip>
                  <el-button
                    v-if="aiGenerateStatus === 'generating'"
                    type="text"
                    size="small"
                    style="margin-right: 10px"
                    disabled
                  >
                    <i class="el-icon-loading"></i> AI文案生成中...
                  </el-button>
                  <el-button
                    v-if="aiGenerateStatus === 'done'"
                    type="text"
                    size="small"
                    style="margin-left: 10px"
                    @click="openAiDialog"
                  >
                    查看文案
                  </el-button>
                </template>
              </message-editor>
              <div v-if="isCatalogAd" class="dpa-variable-tags">
                <span class="dpa-variable-label">插入变量：</span>
                <el-tag
                  v-for="tag in dpaTemplateTags"
                  :key="'msg_' + tag.value"
                  size="mini"
                  type="info"
                  style="cursor: pointer; margin: 2px 4px;"
                  @click="insertCatalogVariable('message', tag.value)"
                >{{ tag.label }}</el-tag>
              </div>
            </el-form-item>
          </el-form>
        </el-col>
        <el-col
          :span="2"
          v-if="currentSelect.length > 1"
        >
          <el-button
            type="text"
            size="mini"
            @click="setBaseData('message')"
            class="mixBtn"
            >恢复初始值</el-button
          >
        </el-col>
      </el-row>
    </div>
    <!-- 正文混合值编辑弹窗 -->
    <el-dialog
      title="编辑正文"
      :visible.sync="messageMixShow"
      width="600px"
      append-to-body
    >
      <message-editor
        :value="messageMixEditValue"
        @change="onMessageMixChange"
        placeholder="正文：介绍广告内容"
      >
        <template #extra>
          <el-tooltip
            :disabled="!isMultipleSelected"
            content="选择多条数据时不支持AI推荐文案"
            placement="top"
          >
            <span style="margin-left: 10px">
              <el-tooltip
                effect="dark"
                placement="top"
              >
                <div slot="content">
                  目前仅支持中文、英语、葡萄牙语、西班牙语 <br />
                  官方说明文档：<a
                    href="https://www.facebook.com/business/help/497610041230617?locale=zh_CN"
                    target="_blank"
                    style="color: #409eff"
                    >https://www.facebook.com/business/help/497610041230617?locale=zh_CN</a
                  >
                </div>
                <el-button
                  type="text"
                  size="small"
                  @click="handleGenerateAiText"
                  :disabled="aiGenerateStatus === 'generating' || isMultipleSelected"
                >
                  智能文案推荐
                </el-button>
              </el-tooltip>
            </span>
          </el-tooltip>
          <el-button
            v-if="aiGenerateStatus === 'generating'"
            type="text"
            size="small"
            disabled
          >
            <i class="el-icon-loading"></i> AI文案生成中...
          </el-button>
          <el-button
            v-if="aiGenerateStatus === 'done'"
            type="text"
            size="small"
            @click="openAiDialog"
          >
            查看文案
          </el-button>
        </template>
      </message-editor>
      <span
        slot="footer"
        class="dialog-footer"
      >
        <el-button @click="messageMixShow = false">取 消</el-button>
        <el-button
          type="primary"
          @click="confirmMessageMix"
          >确 定</el-button
        >
      </span>
    </el-dialog>
    <!-- AI文案推荐抽屉 -->
    <ai-text-drawer
      v-model="aiDialogVisible"
      :content-list="aiContentList"
      :loading="aiLoading"
      @confirm="handleAiConfirm"
    />
    <div
      class="targetingItem"
      v-if="!adTypesHasAssetFeed && !isAdvancedCreative && objective == 'OUTCOME_SALES'"
    >
      <p
        class="baseName"
        v-if="!isNotMix(titleList)"
      >
        <span class="lebel">标题：</span>
        <span>
          <el-button
            type="text"
            size="mini"
            @click="titleMixShow = true"
            >混合值查看及编辑</el-button
          >
        </span>
      </p>
      <el-row v-if="isNotMix(titleList)">
        <el-col :span="20">
          <el-form label-width="140px">
            <el-form-item label="标题：">
              <message-editor
                :value="titleArray"
                @change="onTitleChange"
                label="标题"
                add-button-text="添加标题"
                input-type="text"
                placeholder="请输入标题"
                :max="5"
              />
              <div v-if="isCatalogAd" class="dpa-variable-tags">
                <span class="dpa-variable-label">插入变量：</span>
                <el-tag
                  v-for="tag in dpaTemplateTags"
                  :key="'title_' + tag.value"
                  size="mini"
                  type="info"
                  style="cursor: pointer; margin: 2px 4px;"
                  @click="insertCatalogVariable('title', tag.value)"
                >{{ tag.label }}</el-tag>
              </div>
            </el-form-item>
          </el-form>
        </el-col>
        <el-col
          :span="2"
          v-if="currentSelect.length > 1"
          ><el-button
            type="text"
            size="mini"
            @click="titleMixShow = true"
            class="mixBtn"
            >混合值查看及编辑</el-button
          ></el-col
        >
      </el-row>
    </div>
    <div
      class="targetingItem"
      v-if="!adTypesHasAssetFeed && !isAdvancedCreative && objective == 'OUTCOME_SALES'"
    >
      <p
        class="baseName"
        v-if="!isNotMix(discriList)"
      >
        <span class="lebel">描述：</span>
        <span>
          <el-button
            type="text"
            size="mini"
            @click="discriMixShow = true"
            >混合值查看及编辑</el-button
          >
        </span>
      </p>
      <el-row v-if="isNotMix(discriList)">
        <el-col :span="20">
          <el-form label-width="140px">
            <el-form-item label="描述：">
              <message-editor
                :value="discriArray"
                @change="onDiscriChange"
                label="描述"
                add-button-text="添加描述"
                input-type="text"
                placeholder="描述：添加其他详情"
                :max="5"
              />
              <div v-if="isCatalogAd" class="dpa-variable-tags">
                <span class="dpa-variable-label">插入变量：</span>
                <el-tag
                  v-for="tag in dpaTemplateTags"
                  :key="'discri_' + tag.value"
                  size="mini"
                  type="info"
                  style="cursor: pointer; margin: 2px 4px;"
                  @click="insertCatalogVariable('discri', tag.value)"
                >{{ tag.label }}</el-tag>
              </div>
            </el-form-item>
          </el-form>
        </el-col>
        <el-col
          :span="2"
          v-if="currentSelect.length > 1"
          ><el-button
            type="text"
            size="mini"
            @click="discriMixShow = true"
            class="mixBtn"
            >混合值查看及编辑</el-button
          ></el-col
        >
      </el-row>
    </div>
    <!-- <div class="targetingItem">
            <p class="baseName" v-if="!isNotMix(discriList)">
                <span class="lebel">描述：</span>
                <span>
                    <el-button type="text" size="mini" @click="discriMixShow = true">混合值查看及编辑</el-button>
                </span>
            </p>
            <el-row  v-if="isNotMix(discriList)" >
                <el-col :span="20">
                    <discri :label-width="labelWidth" :discriMsg="discriMsg" @getDiscriMsg="getDiscriMsg"></discri>
                </el-col>
                <el-col :span="2" v-if="currentSelect.length>1"><el-button type="text" size="mini"  @click="discriMixShow = true" class="mixBtn">混合值查看及编辑</el-button></el-col>
            </el-row>
        </div> -->
    <div
      class="targetingItem"
      v-if="
        !isAdvancedCreative &&
        ((!adTypesHasAssetFeed && objective == 'OUTCOME_SALES') || (objective == 'POST_ENGAGEMENT' && hasLink))
      "
    >
      <p
        class="baseName"
        v-if="!isNotMix(urlList)"
      >
        <span class="lebel">网址：</span>
        <span>
          <el-button
            type="text"
            size="mini"
            @click="urlMixShow = true"
            >混合值查看及编辑</el-button
          >
        </span>
      </p>
      <el-row v-if="isNotMix(urlList)">
        <el-col :span="20">
          <url
            :label-width="labelWidth"
            :urlMsg="urlMsg"
            @getUrlMsg="getUrlMsg"
          ></url>
        </el-col>
        <el-col
          :span="2"
          v-if="currentSelect.length > 1"
          ><el-button
            type="text"
            size="mini"
            @click="urlMixShow = true"
            class="mixBtn"
            >混合值查看及编辑</el-button
          ></el-col
        >
      </el-row>
    </div>
    <div
      class="targetingItem"
      v-if="objective == 'OUTCOME_SALES'"
    >
      <p
        class="baseName"
        v-if="!isNotMix(domainList)"
      >
        <span class="lebel">网域：</span>
        <span>
          <el-button
            type="text"
            size="mini"
            @click="domainMixShow = true"
            >混合值查看及编辑</el-button
          >
        </span>
      </p>
      <el-row v-if="isNotMix(domainList)">
        <el-col :span="20">
          <domain
            :label-width="labelWidth"
            :domainMsg="domainMsg"
            @getDomainMsg="getDomainMsg"
          ></domain>
        </el-col>
        <el-col
          :span="2"
          v-if="currentSelect.length > 1"
          ><el-button
            type="text"
            size="mini"
            @click="domainMixShow = true"
            class="mixBtn"
            >混合值查看及编辑</el-button
          ></el-col
        >
      </el-row>
    </div>
    <div
      class="targetingItem"
      v-if="objective == 'OUTCOME_SALES'"
    >
      <p
        class="baseName"
        v-if="!isNotMix(showUrlList)"
      >
        <span class="lebel">显示链接：</span>
        <span>
          <el-button
            type="text"
            size="mini"
            @click="showUrlMixShow = true"
            >混合值查看及编辑</el-button
          >
        </span>
      </p>
      <el-row v-if="isNotMix(showUrlList)">
        <el-col :span="20">
          <show-url
            :label-width="labelWidth"
            :showUrlMsg="showUrlMsg"
            @getShowUrlMsg="getShowUrlMsg"
          ></show-url>
        </el-col>
        <el-col
          :span="2"
          v-if="currentSelect.length > 1"
          ><el-button
            type="text"
            size="mini"
            @click="showUrlMixShow = true"
            class="mixBtn"
            >混合值查看及编辑</el-button
          ></el-col
        >
      </el-row>
    </div>
    <div
      class="targetingItem"
      v-if="!adTypesHasAssetFeed && !isAdvancedCreative && objective !== 'PAGE_LIKES'"
    >
      <p
        class="baseName"
        v-if="!isNotMix(actionTypeList)"
      >
        <span class="lebel">行动号召：</span>
        <span>
          <el-button
            type="text"
            size="mini"
            @click="actionTypeMixShow = true"
            >混合值查看及编辑</el-button
          >
        </span>
      </p>
      <el-row v-if="isNotMix(actionTypeList)">
        <el-col :span="20">
          <action-type
            :label-width="labelWidth"
            :actionTypeMsg="actionTypeMsg"
            @getActionTypeMsg="getActionTypeMsg"
            :callToActions="callToActions"
          ></action-type>
        </el-col>
        <el-col
          :span="2"
          v-if="currentSelect.length > 1"
          ><el-button
            type="text"
            size="mini"
            @click="actionTypeMixShow = true"
            class="mixBtn"
            >混合值查看及编辑</el-button
          ></el-col
        >
      </el-row>
    </div>
    <!-- 进阶创意模式下的链接 -->
    <div
      class="targetingItem"
      v-if="isAdvancedCreative && !adTypesHasAssetFeed"
    >
      <p
        class="baseName"
        v-if="!isNotMix(advancedLinkUrlsList)"
      >
        <span class="lebel">推广网址：</span>
        <span>
          <el-tooltip
            class="item"
            effect="dark"
            content="链接编辑后将会统一"
            placement="top-start"
          >
            <el-button
              type="text"
              size="mini"
              @click="editMix('editAdvancedLinks')"
              >混合值编辑</el-button
            >
          </el-tooltip>
        </span>
      </p>
      <el-row v-if="advancedLinkUrlsList.length && (isNotMix(advancedLinkUrlsList) || editAdvancedLinks)">
        <el-col :span="20">
          <el-form
            ref="advancedLinkForm"
            label-width="140px"
            class="demo-ruleForm"
          >
            <el-form-item label="推广网址">
              <el-input
                v-model="advancedLinkUrlMsg"
                placeholder="请输入推广网址"
                @change="getAdvancedLinkUrlsMsg"
              ></el-input>
            </el-form-item>
          </el-form>
        </el-col>
      </el-row>
    </div>
    <!-- 进阶创意模式下的行动号召 -->
    <div
      class="targetingItem"
      v-if="isAdvancedCreative && !adTypesHasAssetFeed && objective !== 'PAGE_LIKES'"
    >
      <p
        class="baseName"
        v-if="!isNotMix(advancedActionTypesList)"
      >
        <span class="lebel">行动号召：</span>
        <span>
          <el-tooltip
            class="item"
            effect="dark"
            content="行动号召编辑后将会统一"
            placement="top-start"
          >
            <el-button
              type="text"
              size="mini"
              @click="editMix('editAdvancedActions')"
              >混合值编辑</el-button
            >
          </el-tooltip>
        </span>
      </p>
      <el-row v-if="advancedActionTypesList.length && (isNotMix(advancedActionTypesList) || editAdvancedActions)">
        <el-col :span="20">
          <el-form
            ref="advancedActionForm"
            label-width="140px"
            class="demo-ruleForm"
          >
            <el-form-item label="行动号召">
              <el-select
                v-model="advancedActionTypesMsg"
                placeholder="请选择行动号召"
                multiple
                collapse-tags
                :multiple-limit="5"
                @change="getAdvancedActionTypesMsg"
              >
                <el-option
                  v-for="action in callToActions"
                  :key="action.key"
                  :label="action.desc"
                  :value="action.key"
                ></el-option>
              </el-select>
            </el-form-item>
          </el-form>
        </el-col>
      </el-row>
    </div>
    <div
      class="targetingItem"
      v-if="adTypesHasAssetFeed"
    >
      <p
        class="baseName"
        v-if="!isNotMix(webLinkLists)"
      >
        <span class="lebel">网址：</span>
        <span>
          <el-tooltip
            class="item"
            effect="dark"
            content="网址编辑后将会统一"
            placement="top-start"
          >
            <el-button
              type="text"
              size="mini"
              @click="editMix('editWebLinks')"
              >混合值编辑</el-button
            >
          </el-tooltip>
        </span>
      </p>
      <el-row v-if="webLinkLists.length && (isNotMix(webLinkLists) || editWebLinks)">
        <el-col :span="20">
          <el-form
            ref="ruleForm"
            label-width="140px"
            class="demo-ruleForm"
          >
            <asset-feed-actions
              v-model="webLinkListsMsg"
              @input="getWebLinkListsMsg"
            ></asset-feed-actions>
          </el-form>
        </el-col>
        <!-- <el-col :span="2" v-if="currentSelect.length>1"><el-button type="text" size="mini"  @click="setBase('locations')" class="mixBtn">恢复初始值</el-button></el-col> -->
      </el-row>
    </div>
    <div
      class="targetingItem"
      v-if="adTypesHasAssetFeed"
    >
      <p
        class="baseName"
        v-if="!isNotMix(actionsTypeList)"
      >
        <span class="lebel">行动号召：</span>
        <span>
          <el-tooltip
            class="item"
            effect="dark"
            content="行动号召编辑后将会统一"
            placement="top-start"
          >
            <el-button
              type="text"
              size="mini"
              @click="editMix('editActionsTypes')"
              >混合值编辑</el-button
            >
          </el-tooltip>
        </span>
      </p>
      <el-row v-if="actionsTypeList.length && (isNotMix(actionsTypeList) || editActionsTypes)">
        <el-col :span="20">
          <el-form
            ref="ruleForm"
            label-width="140px"
            class="demo-ruleForm"
          >
            <action-select
              v-model="actionTypeListMsg"
              :initData="$store.getters.initData"
              @input="getActionTypeListMsg"
            ></action-select>
          </el-form>
        </el-col>
        <!-- <el-col :span="2" v-if="currentSelect.length>1"><el-button type="text" size="mini"  @click="setBase('locations')" class="mixBtn">恢复初始值</el-button></el-col> -->
      </el-row>
    </div>
    <name-mix
      title="名称"
      :nameMsgList="nameMsgList"
      :nameMixShow.sync="nameMixShow"
      @setMixMsg="setMixMsg"
    ></name-mix>
    <status-mix
      title="状态"
      :statusMsgList="statusMsgList"
      :statusMixShow.sync="statusMixShow"
      @setMixMsg="setMixMsg"
    ></status-mix>
    <page-mix
      :pageMsgList="pageMessageList"
      :pageList="pageList"
      :pageMixShow.sync="pageMixShow"
      @setMixMsg="setMixMsg"
      :account="account"
      :targetUserId="targetUserId"
    ></page-mix>

    <title-mix
      :titleMsgList="titleMsgList"
      :titleMixShow.sync="titleMixShow"
      @setMixMsg="setMixMsg"
    ></title-mix>
    <discri-mix
      :discriMsgList="discriMsgList"
      :discriMixShow.sync="discriMixShow"
      @setMixMsg="setMixMsg"
    ></discri-mix>
    <url-mix
      title="网址"
      :urlMsgList="urlMsgList"
      :urlMixShow.sync="urlMixShow"
      @setMixMsg="setMixMsg"
    ></url-mix>
    <domain-mix
      :domainMsgList="domainMsgList"
      :domainMixShow.sync="domainMixShow"
      @setMixMsg="setMixMsg"
    ></domain-mix>
    <show-url-mix
      title="显示链接"
      :showUrlMsgList="showUrlMsgList"
      :showUrlMixShow.sync="showUrlMixShow"
      @setMixMsg="setMixMsg"
    ></show-url-mix>
    <action-type-mix
      :actionTypeMsgList="actionTypeMsgList"
      :actionTypeMixShow.sync="actionTypeMixShow"
      @setMixMsg="setMixMsg"
    ></action-type-mix>
    <!-- {{ adTypeMsg }} -->
    <ad-type
      :adTypeMsg="adTypeMsg"
      @getAdTypeMsg="getAdTypeMsg"
      :adTypeMixShow.sync="adTypeMixShow"
      :objective="objective"
      :targetUserId="targetUserId"
      :account="account"
      :currentSelect="currentSelect"
      @setThumbList="setThumbList"
      @advancedVideoStatusUpdate="onAdvancedVideoStatusUpdate"
      :videoMap="videoMap"
      :pageId="pageMsg.page_id"
      :instagramActorId="pageMsg.instagram_actor_id"
    ></ad-type>
    <post-id-mix
      :postIdMsgList="postIdMsgList"
      :postIdMixShow.sync="postIdMixShow"
    ></post-id-mix>
  </div>
</template>
<script>
import page from './page';
import pageMix from './pageMix';
import title1 from './title.vue';
import titleMix from './titleMix.vue';
import discri from './discri.vue';
import discriMix from './discriMix.vue';
import url from './url.vue';
import urlMix from './urlMix.vue';
import showUrl from './showUrl.vue';
import showUrlMix from './showUrlMix.vue';
import actionTypeMix from './actionTypeMix.vue';
import actionType from './actionType.vue';
import adType from './adType.vue';
import name from '../campaign/name';
import nameMix from '../campaign/nameMix';
import status from '../campaign/status';
import statusMix from '../campaign/statusMix';
import domain from './domain';
import domainMix from './domainMix';
import postId from './postId.vue';
import postIdMix from './postIdMix.vue';
import { accountPages, querySlideshowVideoBatch, textGeneration, textGenerationQuery } from '@/api/creatAd.js';
import actionTypes from '@/views/adManagement/createAd/components/assetFeed/actionType.vue';
import actionSelect from '@/views/adManagement/createAd/components/assetFeed/actionSelect.vue';
import assetFeedActions from './assetFeedActions.vue';
import MessageEditor from '@/views/adManagement/createAd/components/adsComponents/messageEditor.vue';
import AiTextDrawer from '@/views/adManagement/createAd/components/adsComponents/aiTextDrawer.vue';
export default {
  props: ['currentSelect', 'baseData', 'updateList', 'account', 'show_mood', 'targetUserId', 'edit'],
  data() {
    return {
      labelWidth: '140px',
      listData: JSON.parse(JSON.stringify(this.updateList)),
      isInitializing: true,
      pageMsgList: [],
      messageList: [],
      titleList: [],
      discriList: [],
      urlList: [],
      showUrlList: [],
      actionTypeList: [],
      urlPramsList: [],
      adTypeList: [],
      pageMsg: {},
      messageMsg: [],
      titleMsg: { title: [''] },
      discriMsg: { content: [''] },
      urlMsg: {},
      showUrlMsg: {},
      actionTypeMsg: {},
      urlPramsMsg: {},
      adTypeMsg: {},
      pageMixShow: false,
      messageMixShow: false,
      titleMixShow: false,
      discriMixShow: false,
      urlMixShow: false,
      showUrlMixShow: false,
      actionTypeMixShow: false,
      adTypeMixShow: false,
      nameMixShow: false,
      statusMixShow: false,
      nameMsg: '',
      statusMsg: '',
      nameList: [],
      statusList: [],
      loadPages: false,
      pageList: [],
      domainList: [],
      domainMsg: {},
      domainMixShow: false,
      // 动态广告
      actionsTypeList: [],
      webLinkLists: [],
      editWebLinks: false,
      editActionsTypes: false,
      webLinkListsMsg: [],
      actionTypeListMsg: [],
      postIdList: [],
      postIdMsg: {},
      postIdMixShow: false,
      videoMap: {},
      timer: null,
      videoUploadId: [],
      cancleGetbatchVideoStatus: false,
      // 进阶创意
      advancedLinkUrlsList: [],
      advancedActionTypesList: [],
      editAdvancedLinks: false,
      editAdvancedActions: false,
      advancedLinkUrlMsg: '',
      advancedActionTypesMsg: [],
      // AI文案推荐
      aiDialogVisible: false,
      aiLoading: false,
      aiContentList: [],
      aiGenerateStatus: 'idle',
      currentCreativeId: null,
      queryTimer: null,
      // 正文混合值编辑
      messageMixEditValue: [''],
      // 目录广告模板变量
      dpaTemplateTags: [
        { label: '商品名称', value: '{{product.name}}' },
        { label: '商品价格', value: '{{product.price}}' },
        { label: '当前价格', value: '{{product.current_price}}' },
        { label: '商品描述', value: '{{product.description}}' },
        { label: '简短描述', value: '{{product.short_description}}' },
        { label: '品牌', value: '{{product.brand}}' },
      ],
    };
  },
  components: {
    page,
    pageMix,
    title1,
    titleMix,
    discri,
    discriMix,
    url,
    urlMix,
    showUrl,
    showUrlMix,
    actionType,
    actionTypeMix,
    adType,
    name,
    nameMix,
    status,
    statusMix,
    domain,
    domainMix,
    actionTypes,
    actionSelect,
    assetFeedActions,
    postId,
    postIdMix,
    MessageEditor,
    AiTextDrawer,
  },
  computed: {
    // 是否选择了多条数据（两条及以上）
    isMultipleSelected() {
      return this.currentSelect && this.currentSelect.length >= 2;
    },
    callToActions() {
      let initData = this.$store.getters.initData;
      let business = this.objective == 'OUTCOME_SALES' ? '网站' : 'FACEBOOK_PAGE';
      if (initData && initData.ad) {
        return initData.ad.BusinessType.find((v) => v.key == business).objectives.find((k) => k.key == this.objective)
          .callToActions;
      } else {
        return [];
      }
    },
    hasLink() {
      let action_type = this.actionTypeMsg.action_type || '';
      if (this.callToActions.length && action_type) {
        return this.callToActions.find((v) => v.key == action_type).link;
      } else {
        return false;
      }
    },
    objective() {
      let list = [];
      this.currentSelect.map((v) => {
        this.listData.map((m) => {
          if (m.id == v) {
            list.push(m.objective);
          }
        });
      });
      console.log('-------');
      console.log(list.includes('PAGE_LIKES'));
      console.log(list.includes('POST_ENGAGEMENT'));

      if (list.includes('PAGE_LIKES')) {
        return 'PAGE_LIKES';
      } else if (list.includes('POST_ENGAGEMENT')) {
        return 'POST_ENGAGEMENT';
      } else {
        return 'OUTCOME_SALES';
      }
    },
    // 广告样式
    adTypesHasAssetFeed() {
      console.log('adTypesHasAssetFeed', this.adTypeList.map((v) => v.media_type).includes('asset_feed'));
      return this.adTypeList.map((v) => v.media_type).includes('asset_feed');
    },
    // 是否是进阶创意模式
    isAdvancedCreative() {
      // 检查当前选中的广告是否有进阶创意
      return this.adTypeList.some((v) => v.isAdvancedCreative);
    },
    // 是否是目录广告（catalog）模式
    isCatalogAd() {
      return this.adTypeList.some((v) => v.media_type === 'catalog');
    },
    // 是否是进阶目录广告（catalog + advanced_material_enabled）
    isCatalogAdvanced() {
      return this.adTypeList.some((v) => v.media_type === 'catalog' && v.advanced_material_enabled);
    },
    nameMsgList() {
      let list = [];
      this.currentSelect.map((v) => {
        this.listData.map((m) => {
          if (m.id == v) {
            let nameObj = {};
            // 主页
            nameObj.name = m.name || '';
            nameObj.id = m.id;
            list.push(nameObj);
          }
        });
      });
      return list;
    },
    statusMsgList() {
      let list = [];
      this.currentSelect.map((v) => {
        this.listData.map((m) => {
          if (m.id == v) {
            let statusObj = {};
            // 主页
            statusObj.status = m.status || '';
            statusObj.id = m.id;
            statusObj.name = m.name;
            list.push(statusObj);
          }
        });
      });
      return list;
    },
    pageMessageList() {
      let list = [];
      this.currentSelect.map((v) => {
        this.listData.map((m) => {
          if (m.id == v) {
            let pageObj = {};
            // 主页
            pageObj.page_id = m.creative.page_id || '';
            pageObj.instagram_actor_id = m.creative.instagram_actor_id || '';
            pageObj.name = m.name || '';
            pageObj.id = m.id;
            list.push(pageObj);
          }
        });
      });
      return list;
    },
    messageMsgList() {
      let list = [];
      this.currentSelect.map((v) => {
        this.listData.map((m) => {
          if (m.id == v) {
            // 正文
            list.push({ message: m.creative.message || '', name: m.name, id: m.id });
          }
        });
      });
      return list;
    },
    postIdMsgList() {
      let list = [];
      this.currentSelect.map((v) => {
        this.listData.map((m) => {
          if (m.id == v) {
            // 帖子Id
            list.push({ post_id: m.creative.post_id || '', name: m.name, id: m.id });
          }
        });
      });
      return list;
    },
    titleMsgList() {
      let list = [];
      this.currentSelect.map((v) => {
        this.listData.map((m) => {
          if (m.id == v) {
            // 标题
            list.push({ title: m.creative.title || '', name: m.name, id: m.id });
          }
        });
      });
      return list;
    },
    discriMsgList() {
      let list = [];
      this.currentSelect.map((v) => {
        this.listData.map((m) => {
          if (m.id == v) {
            // 描述
            list.push({ content: m.creative.content || '', name: m.name, id: m.id });
          }
        });
      });
      return list;
    },
    urlMsgList() {
      let list = [];
      this.currentSelect.map((v) => {
        this.listData.map((m) => {
          if (m.id == v) {
            // 网址
            list.push({ web_url: m.creative.web_url || '', name: m.name, id: m.id });
          }
        });
      });
      return list;
    },
    domainMsgList() {
      let list = [];
      this.currentSelect.map((v) => {
        this.listData.map((m) => {
          if (m.id == v) {
            // 网址
            list.push({ domain: m.conversion_domain || '', name: m.name, id: m.id });
          }
        });
      });
      return list;
    },
    showUrlMsgList() {
      let list = [];
      this.currentSelect.map((v) => {
        this.listData.map((m) => {
          if (m.id == v) {
            // 显示链接
            list.push({ show_url: m.creative.show_url || '', name: m.name, id: m.id });
          }
        });
      });
      return list;
    },
    actionTypeMsgList() {
      let list = [];
      this.currentSelect.map((v) => {
        this.listData.map((m) => {
          if (m.id == v) {
            // 行动号召
            list.push({ action_type: m.creative.action_type || '', name: m.name, id: m.id });
          }
        });
      });
      return list;
    },
    // videoUploadId(){
    //   console.log(this.listData.filter((v)=>v.creative.media_type == 'video' && v.creative.videoStatus != 'ready'));

    // }
    // 将message转换为数组格式
    messageArray() {
      const msg = this.messageMsg;
      if (Array.isArray(msg)) {
        return msg.length ? msg : [''];
      }
      return msg ? [msg] : [''];
    },
    // 将title转换为数组格式
    titleArray() {
      const t = this.titleMsg.title;
      if (Array.isArray(t)) {
        return t.length ? t : [''];
      }
      return t ? [t] : [''];
    },
    // 将描述转换为数组格式
    discriArray() {
      const c = this.discriMsg.content;
      if (Array.isArray(c)) {
        return c.length ? c : [''];
      }
      return c ? [c] : [''];
    },
  },

  methods: {
    setThumbList(key, value) {
      this.videoMap[key] = JSON.parse(JSON.stringify(value));
    },
    // 编辑混合值
    editMix(v) {
      this[v] = true;
    },
    // 判断是否是混合值
    isNotMix(list) {
      return !list.some((v) => {
        return JSON.stringify(v) != JSON.stringify(list[0]);
      });
    },
    emitData() {
      //   if (!this.isInitializing) {
      this.$emit('setAdData', this.listData);
      //   }
    },
    async getAccountPage(v) {
      //console.log(v);
      this.loadPages = true;
      await accountPages({ accountId: this.account, force: v }, this.targetUserId).then((res) => {
        this.loadPages = false;
        let canUse = res.data.filter((v) => v.is_published);
        let notUse = res.data.filter((v) => !v.is_published);
        this.pageList = canUse.concat(notUse);
        if (v) {
          this.$message('更新成功');
        }
      });
    },
    // 获取主页
    getPages(v) {
      //console.log('ssssssss');
      this.getAccountPage(v);
    },
    // 设置每一项的列表
    setList() {
      let pageMsgList = [],
        messageList = [],
        titleList = [],
        discriList = [],
        urlList = [],
        showUrlList = [],
        actionTypeList = [],
        urlPramsList = [],
        adTypeList = [],
        nameList = [],
        statusList = [],
        domainList = [],
        webLinkLists = [],
        actionsTypeList = [],
        postIdList = [],
        advancedLinkUrlsList = [],
        advancedActionTypesList = [];
      this.currentSelect.map((v) => {
        this.listData.map((m) => {
          if (m.id == v) {
            // 名称
            nameList.push(m.name);
            // 状态
            statusList.push(m.status);
            let pageObj = {};
            // 主页
            pageObj.page_id = m.creative.page_id || '';
            pageObj.instagram_actor_id = m.creative.instagram_actor_id || '';
            pageMsgList.push(pageObj);

            // catalog 广告从 templateData 中取值
            const isCatalog = m.creative.media_type === 'catalog';
            const tpl = isCatalog ? (m.creative.templateData || {}) : {};
            const cafs = isCatalog ? (m.creative.catalogAssetFeedSpec || {}) : {};

            // 正文：catalog 广告多正文存在 catalogAssetFeedSpec.bodies 中
            if (isCatalog && cafs.bodies && cafs.bodies.length > 0) {
              messageList.push({ message: cafs.bodies.map(b => b.text).filter(t => t) });
            } else {
              messageList.push({ message: isCatalog ? tpl.message : m.creative.message });
            }
            // 标题：catalog 广告多标题存在 catalogAssetFeedSpec.titles 中
            if (isCatalog && cafs.titles && cafs.titles.length > 0) {
              titleList.push({ title: cafs.titles.map(t => t.text).filter(t => t) });
            } else {
              titleList.push({ title: isCatalog ? tpl.name : m.creative.title });
            }
            // 描述：catalog 广告多描述存在 catalogAssetFeedSpec.descriptions 中
            if (isCatalog && cafs.descriptions && cafs.descriptions.length > 0) {
              discriList.push({ content: cafs.descriptions.map(d => d.text).filter(t => t) });
            } else {
              discriList.push({ content: isCatalog ? tpl.description : m.creative.content });
            }
            // 网址
            urlList.push({ web_url: isCatalog ? tpl.link : m.creative.web_url });
            // 网域
            domainList.push({ domain: m.conversion_domain });
            // 显示链接
            showUrlList.push({ show_url: m.creative.show_url });
            // 行动号召
            actionTypeList.push({ action_type: isCatalog ? tpl.callToActionType : m.creative.action_type });
            // 帖子Id
            postIdList.push({ post_id: m.creative.post_id });
            // 广告类型
            let adObj = {};
            adObj.media_type = m.creative.media_type;
            adObj.saleId = m.creative.saleId;
            adObj.langId = m.creative.langId;
            adObj.productId = m.creative.productId;
            // 视频
            adObj.videoStatus = m.creative.videoStatus;
            adObj.videoId = m.creative.videoId;
            adObj.mediaSourceType = m.creative.mediaSourceType;
            adObj.mediaOptLogId = m.creative.mediaOptLogId;
            // 进阶创意
            adObj.isAdvancedCreative = m.creative.isAdvancedCreative;
            if (m.creative.isAdvancedCreative && m.creative.fbAssetFeedSpec) {
              adObj.fbAssetFeedSpec = { ...m.creative.fbAssetFeedSpec };
              // 进阶创意的链接和行动号召
              advancedLinkUrlsList.push(m.creative.fbAssetFeedSpec.linkUrls || ['']);
              advancedActionTypesList.push(m.creative.fbAssetFeedSpec.actionTypes || ['']);
            }
            // 始终设置 image 和 source_id（进阶创意需要回显素材）
            adObj.image = m.creative.image;
            adObj.source_id = m.creative.source_id;
            if (m.creative.media_type == 'video') {
              adObj.thumbUrl = m.creative.thumbUrl;
            } else if (m.creative.media_type == 'post') {
              adObj.post_id = m.creative.post_id;
            } else if (m.creative.media_type == 'muti') {
              adObj.mutiImgs = [...(m.creative.mutiImgs || [])];
            } else if (m.creative.media_type == 'asset_feed') {
              let { optimizationType, actionTypes, linkUrls, ...fbAssetFeedSpec } = m.creative.fbAssetFeedSpec;
              adObj.fbAssetFeedSpec = fbAssetFeedSpec;
            } else if (m.creative.media_type == 'catalog') {
              adObj.templateData = m.creative.templateData ? { ...m.creative.templateData } : {};
              adObj.catalogAssetFeedSpec = m.creative.catalogAssetFeedSpec ? { ...m.creative.catalogAssetFeedSpec } : null;
              adObj.advanced_material_enabled = m.creative.advanced_material_enabled;
            }
            adTypeList.push(adObj);
            //console.log(adTypeList);
            //console.log(this.isNotMix(adTypeList));
            // 若为动态广告
            if (m.creative.fbAssetFeedSpec && m.creative.media_type == 'asset_feed') {
              m.creative.fbAssetFeedSpec.linkUrls = m.creative.fbAssetFeedSpec.linkUrls;
              webLinkLists.push(m.creative.fbAssetFeedSpec.linkUrls || ['']);
              actionsTypeList.push(m.creative.fbAssetFeedSpec.actionTypes || ['']);
            }

            // 网址参数
            // urlPramsList.push({action_type:m.creative.action_type,name:m.name,id:m.id})
          }
        });
      });
      this.pageMsgList = pageMsgList;
      this.messageList = messageList;
      this.titleList = titleList;
      this.discriList = discriList;
      this.urlList = urlList;
      this.showUrlList = showUrlList;
      this.actionTypeList = actionTypeList;
      this.adTypeList = adTypeList;
      this.nameList = nameList;
      this.statusList = statusList;
      this.domainList = domainList;
      this.webLinkLists = webLinkLists;
      this.actionsTypeList = actionsTypeList;
      this.postIdList = postIdList;
      // 进阶创意
      this.advancedLinkUrlsList = advancedLinkUrlsList;
      this.advancedActionTypesList = advancedActionTypesList;
      // this.urlPramsList = urlPramsList;
    },
    setMsg() {
      this.setPageMsg();
      this.setMessageMsg();
      this.setTitleMsg();
      this.setDiscriMsg();
      this.setUrlMsg();
      this.setShowUrlMsg();
      this.setActionTypeMsg();
      this.setAdTypeMsg();
      this.setNameMsg();
      this.setStatusMsg();
      this.setDomainMsg();
      this.setActionTypeListMsg();
      this.setWebLinkListMsg();
      this.setDomainMsg();
      this.setPostIdMsg();
      this.setAdvancedLinkUrlsMsg();
      this.setAdvancedActionTypesMsg();
    },
    setPageMsg() {
      this.pageMsg = this.isNotMix(this.pageMsgList)
        ? { page_id: this.pageMsgList[0].page_id, instagram_actor_id: this.pageMsgList[0].instagram_actor_id }
        : { page_id: '', instagram_actor_id: '' };
    },
    setMessageMsg() {
      // 获取第一个选中项的message作为基准
      if (this.messageList.length > 0) {
        const firstMsg = this.messageList[0].message;
        if (Array.isArray(firstMsg)) {
          this.messageMsg = firstMsg.length ? [...firstMsg] : [''];
        } else {
          this.messageMsg = firstMsg ? [firstMsg] : [''];
        }
      } else {
        this.messageMsg = [''];
      }
    },
    setTitleMsg() {
      if (this.isNotMix(this.titleList)) {
        const rawTitle = this.titleList[0].title;
        // 保持数组格式
        if (Array.isArray(rawTitle)) {
          this.titleMsg = { title: rawTitle.length ? [...rawTitle] : [''] };
        } else {
          this.titleMsg = { title: rawTitle ? [rawTitle] : [''] };
        }
      } else {
        this.titleMsg = { title: [''] };
      }
    },
    setDiscriMsg() {
      if (this.isNotMix(this.discriList)) {
        const rawContent = this.discriList[0].content;
        // 保持数组格式
        if (Array.isArray(rawContent)) {
          this.discriMsg = { content: rawContent.length ? [...rawContent] : [''] };
        } else {
          this.discriMsg = { content: rawContent ? [rawContent] : [''] };
        }
      } else {
        this.discriMsg = { content: [''] };
      }
    },
    setUrlMsg() {
      this.urlMsg = this.isNotMix(this.urlList) ? { web_url: this.urlList[0].web_url } : { web_url: '' };
    },
    setShowUrlMsg() {
      this.showUrlMsg = this.isNotMix(this.showUrlList) ? { show_url: this.showUrlList[0].show_url } : { show_url: '' };
    },
    setActionTypeMsg() {
      this.actionTypeMsg = this.isNotMix(this.actionTypeList)
        ? { action_type: this.actionTypeList[0].action_type }
        : { action_type: '' };
    },
    setAdTypeMsg() {
      const baseMsg = this.isNotMix(this.adTypeList)
        ? { ...this.adTypeList[0] }
        : { media_type: 'image', image: '', source_id: '' };
      this.adTypeMsg = baseMsg;
      // 如果是进阶创意，确保fbAssetFeedSpec存在
      if (this.adTypeMsg.isAdvancedCreative && !this.adTypeMsg.fbAssetFeedSpec) {
        this.adTypeMsg.fbAssetFeedSpec = {
          titles: [''],
          mDescriptions: [''],
          mBodies: [''],
          imgList: [],
          videos: [],
          actionTypes: [],
          linkUrls: [''],
        };
      }
    },
    setDomainMsg() {
      this.domainMsg = this.isNotMix(this.domainList) ? { ...this.domainList[0] } : { domain: '' };
    },
    setActionTypeListMsg() {
      this.actionTypeListMsg = this.isNotMix(this.actionsTypeList) ? this.actionsTypeList[0] : [''];
      this.editActionsTypes = false;
    },
    setWebLinkListMsg() {
      this.webLinkListsMsg = this.isNotMix(this.webLinkLists) ? this.webLinkLists[0] : [''];
      this.editWebLinks = false;
    },
    setPostIdMsg() {
      this.postIdMsg = this.isNotMix(this.postIdList) ? { ...this.postIdList[0] } : { post_id: '' };
    },
    // 进阶创意链接设置
    setAdvancedLinkUrlsMsg() {
      if (this.isNotMix(this.advancedLinkUrlsList) && this.advancedLinkUrlsList[0]) {
        // 取数组的第一个元素作为单个链接
        this.advancedLinkUrlMsg = this.advancedLinkUrlsList[0][0] || '';
      } else {
        this.advancedLinkUrlMsg = '';
      }
      this.editAdvancedLinks = false;
    },
    // 进阶创意行动号召设置
    setAdvancedActionTypesMsg() {
      this.advancedActionTypesMsg = this.isNotMix(this.advancedActionTypesList)
        ? this.advancedActionTypesList[0]
        : [''];
      this.editAdvancedActions = false;
    },
    // 进阶创意链接获取
    getAdvancedLinkUrlsMsg() {
      const val = this.advancedLinkUrlMsg;
      this.currentSelect.map((v) => {
        this.listData.map((m, i) => {
          if (m.id == v && m.creative.isAdvancedCreative) {
            if (!m.creative.fbAssetFeedSpec) {
              m.creative.fbAssetFeedSpec = {
                titles: [''],
                mDescriptions: [''],
                mBodies: [''],
                imgList: [],
                videos: [],
                actionTypes: [],
                linkUrls: [''],
              };
            }
            // 存储为数组格式，保持与后端接口一致
            m.creative.fbAssetFeedSpec.linkUrls = val ? [val] : [''];
            this.$set(this.listData, i, m);
          }
        });
      });
      this.listData = JSON.parse(JSON.stringify(this.listData));
      this.setList();
      this.emitData();
    },
    // 进阶创意行动号召获取
    getAdvancedActionTypesMsg(val) {
      this.currentSelect.map((v) => {
        this.listData.map((m, i) => {
          if (m.id == v && m.creative.isAdvancedCreative) {
            if (!m.creative.fbAssetFeedSpec) {
              m.creative.fbAssetFeedSpec = {
                titles: [''],
                mDescriptions: [''],
                mBodies: [''],
                imgList: [],
                videos: [],
                actionTypes: [],
                linkUrls: [''],
              };
            }
            m.creative.fbAssetFeedSpec.actionTypes = val;
            this.$set(this.listData, i, m);
          }
        });
      });
      this.listData = JSON.parse(JSON.stringify(this.listData));
      this.setList();
      this.emitData();
    },
    getPageMsg(val) {
      if (JSON.stringify(this.pageMsg) == JSON.stringify(val)) return;
      this.currentSelect.map((v) => {
        this.listData.map((m, i) => {
          if (m.id == v) {
            m.creative.page_id = val.page_id;
            m.creative.instagram_actor_id = val.instagram_actor_id;
            this.$set(this.listData, i, m);
          }
        });
      });
      this.listData = JSON.parse(JSON.stringify(this.listData));
      this.setList();
      this.emitData();
      // this.pageMsg = JSON.parse(JSON.stringify(val))
    },
    getMessageMsg(val) {
      if (JSON.stringify(this.messageMsg) == JSON.stringify(val)) return;
      this.currentSelect.map((v) => {
        this.listData.map((m, i) => {
          if (m.id == v) {
            if (m.creative.media_type === 'catalog' && m.creative.templateData) {
              m.creative.templateData.message = val;
            } else {
              m.creative.message = val;
            }
            this.$set(this.listData, i, m);
          }
        });
      });
      this.listData = JSON.parse(JSON.stringify(this.listData));
      this.setList();
      this.emitData();
    },
    // 正文数组变更
    onMessageChange(val) {
      this.messageMsg = val;
      this.currentSelect.map((v) => {
        this.listData.map((m, i) => {
          if (m.id == v) {
            if (m.creative.media_type === 'catalog' && m.creative.templateData) {
              // catalog 广告：第一条作为 templateData.message，多条存入 catalogAssetFeedSpec.bodies
              const messages = Array.isArray(val) ? val.filter(t => t && t.trim()) : (val ? [val] : []);
              m.creative.templateData.message = messages[0] || '';
              if (messages.length > 1) {
                if (!m.creative.catalogAssetFeedSpec) {
                  m.creative.catalogAssetFeedSpec = {};
                }
                m.creative.catalogAssetFeedSpec.bodies = messages.map(t => ({ text: t }));
                m.creative.catalogAssetFeedSpec.optimization_type = 'DEGREES_OF_FREEDOM';
              } else {
                // 单条正文：清除 bodies
                if (m.creative.catalogAssetFeedSpec) {
                  m.creative.catalogAssetFeedSpec.bodies = null;
                  m.creative.catalogAssetFeedSpec.optimization_type = 'FORMAT_AUTOMATION';
                }
              }
            } else {
              m.creative.message = val;
            }
            this.$set(this.listData, i, m);
          }
        });
      });
      this.listData = JSON.parse(JSON.stringify(this.listData));
      this.setList();
      this.emitData();
    },
    // AI文案推荐相关方法
    async handleGenerateAiText() {
      // 获取当前选中的第一个广告的素材信息
      const firstSelected = this.currentSelect[0];
      const selectedAd = this.listData.find((m) => m.id === firstSelected);
      if (!selectedAd) return;

      const creative = selectedAd.creative || {};
      let materialUrl = creative.image || '';
      let sourceId = creative.source_id || '';
      let thumbUrl = creative.thumbUrl || '';
      const linkUrl = creative.web_url || '';
      const mediaType = creative.media_type || 'image';
      const actionTypeValue = creative.action_type || '';

      // 如果普通创意没有素材，尝试从 fbAssetFeedSpec 获取（从进阶创意切换过来的情况）
      if (!materialUrl && creative.fbAssetFeedSpec) {
        if (mediaType === 'image' && creative.fbAssetFeedSpec.imgList && creative.fbAssetFeedSpec.imgList.length > 0) {
          const firstImg = creative.fbAssetFeedSpec.imgList[0];
          materialUrl = firstImg.url || '';
          sourceId = firstImg.source_id || '';
        } else if (
          mediaType === 'video' &&
          creative.fbAssetFeedSpec.videos &&
          creative.fbAssetFeedSpec.videos.length > 0
        ) {
          const firstVideo = creative.fbAssetFeedSpec.videos[0];
          materialUrl = firstVideo.url || firstVideo.source || '';
          sourceId = firstVideo.source_id || '';
          thumbUrl = firstVideo.thumbUrl || '';
        }
      }

      const materialItem = materialUrl ? { url: materialUrl, source_id: sourceId, thumbUrl: thumbUrl } : null;
      const imgList = mediaType === 'image' && materialItem ? [materialItem] : [];
      const videos = mediaType === 'video' && materialItem ? [materialItem] : [];

      const params = {
        titles: creative.title ? [creative.title] : [],
        mDescriptions: creative.content ? [creative.content] : [],
        mBodies: this.messageArray.filter((v) => v && v.trim()),
        videos: videos,
        imgList: imgList,
        linkUrls: linkUrl ? [linkUrl] : [],
        accountId: String(this.account || ''),
        media_type: mediaType,
        page_id: String(this.pageMsg.page_id || ''),
        instagram_actor_id: String(this.pageMsg.instagram_actor_id || ''),
        actionTypes: actionTypeValue ? [actionTypeValue] : [],
      };

      try {
        this.aiGenerateStatus = 'generating';
        const res = await textGeneration(params);
        if (res.code === 0 && res.data) {
          this.currentCreativeId = res.data;
          this.pollQueryResult();
        } else {
          this.aiGenerateStatus = 'idle';
          //   this.$message.error(res.comment || '生成失败，请重试');
        }
      } catch (error) {
        console.error('textGeneration error:', error);
        this.aiGenerateStatus = 'idle';
        // this.$message.error('生成失败，请重试');
      }
    },
    async pollQueryResult() {
      if (!this.currentCreativeId) return;

      try {
        const res = await textGenerationQuery({ creativeId: this.currentCreativeId });
        if (res.code === 0 && res.data && res.data.length > 0) {
          this.aiContentList = res.data;
          this.aiGenerateStatus = 'done';
          this.$message.success('AI文案生成完成');
        } else if (res.code === 0) {
          this.queryTimer = setTimeout(() => {
            this.pollQueryResult();
          }, 3000);
        } else {
          this.aiGenerateStatus = 'idle';
          this.$message.error(res.comment || '生成失败，请重试');
        }
      } catch (error) {
        console.error('textGenerationQuery error:', error);
        this.queryTimer = setTimeout(() => {
          this.pollQueryResult();
        }, 2000);
      }
    },
    openAiDialog() {
      this.aiDialogVisible = true;
    },
    handleAiConfirm(selectedContents) {
      // 判断是在弹窗中还是在主界面
      const isInMixDialog = this.messageMixShow;
      const currentMessages = isInMixDialog
        ? this.messageMixEditValue.filter((v) => v && v.trim())
        : this.messageArray.filter((v) => v && v.trim());
      const totalCount = currentMessages.length + selectedContents.length;
      if (totalCount > 5) {
        this.$message.warning('文案数量不能超过5个，请减少选择的文案数量');
        return;
      }
      let newMessages = [...currentMessages];
      for (const content of selectedContents) {
        if (!newMessages.includes(content)) {
          newMessages.push(content);
        }
      }
      const finalMessages = newMessages.length ? newMessages : [''];
      if (isInMixDialog) {
        this.messageMixEditValue = finalMessages;
      } else {
        this.onMessageChange(finalMessages);
      }
      // 保持 aiGenerateStatus 为 'done'，这样用户可以继续查看和选择文案
      // this.aiGenerateStatus = 'idle';
      this.$message.success('已添加选中的文案');
    },
    // 混合值弹窗中的正文变更
    onMessageMixChange(val) {
      this.messageMixEditValue = val;
    },
    // 确认混合值编辑
    confirmMessageMix() {
      this.onMessageChange(this.messageMixEditValue);
      this.messageMixShow = false;
      this.$message.success('正文已更新');
    },
    // 目录广告插入变量（追加到最后一个非空输入框末尾）
    insertCatalogVariable(field, variable) {
      if (field === 'message') {
        const arr = [...this.messageArray];
        const lastIdx = arr.length - 1;
        arr[lastIdx] = (arr[lastIdx] || '') + variable;
        this.onMessageChange(arr);
      } else if (field === 'title') {
        const arr = [...this.titleArray];
        const lastIdx = arr.length - 1;
        arr[lastIdx] = (arr[lastIdx] || '') + variable;
        this.onTitleChange(arr);
      } else if (field === 'discri') {
        const arr = [...this.discriArray];
        const lastIdx = arr.length - 1;
        arr[lastIdx] = (arr[lastIdx] || '') + variable;
        this.onDiscriChange(arr);
      }
    },
    // 标题数组变更
    onTitleChange(val) {
      this.titleMsg = { title: val };
      this.currentSelect.map((v) => {
        this.listData.map((m, i) => {
          if (m.id == v) {
            if (m.creative.media_type === 'catalog' && m.creative.templateData) {
              // catalog 广告：第一条作为 templateData.name，多条存入 catalogAssetFeedSpec.titles
              const titles = Array.isArray(val) ? val.filter(t => t && t.trim()) : (val ? [val] : []);
              m.creative.templateData.name = titles[0] || '';
              if (titles.length > 1) {
                if (!m.creative.catalogAssetFeedSpec) {
                  m.creative.catalogAssetFeedSpec = {};
                }
                m.creative.catalogAssetFeedSpec.titles = titles.map(t => ({ text: t }));
              } else {
                if (m.creative.catalogAssetFeedSpec) {
                  m.creative.catalogAssetFeedSpec.titles = null;
                }
              }
            } else {
              m.creative.title = val;
            }
            this.$set(this.listData, i, m);
          }
        });
      });
      this.listData = JSON.parse(JSON.stringify(this.listData));
      this.setList();
      this.emitData();
    },
    // 描述数组变更
    onDiscriChange(val) {
      this.discriMsg = { content: val };
      this.currentSelect.map((v) => {
        this.listData.map((m, i) => {
          if (m.id == v) {
            if (m.creative.media_type === 'catalog' && m.creative.templateData) {
              // catalog 广告：第一条作为 templateData.description，多条存入 catalogAssetFeedSpec.descriptions
              const descriptions = Array.isArray(val) ? val.filter(t => t && t.trim()) : (val ? [val] : []);
              m.creative.templateData.description = descriptions[0] || '';
              if (descriptions.length > 1) {
                if (!m.creative.catalogAssetFeedSpec) {
                  m.creative.catalogAssetFeedSpec = {};
                }
                m.creative.catalogAssetFeedSpec.descriptions = descriptions.map(t => ({ text: t }));
              } else {
                if (m.creative.catalogAssetFeedSpec) {
                  m.creative.catalogAssetFeedSpec.descriptions = null;
                }
              }
            } else {
              m.creative.content = val;
            }
            this.$set(this.listData, i, m);
          }
        });
      });
      this.listData = JSON.parse(JSON.stringify(this.listData));
      this.setList();
      this.emitData();
    },
    getTitleMsg(val) {
      if (JSON.stringify(this.titleMsg) == JSON.stringify(val)) return;
      this.currentSelect.map((v) => {
        this.listData.map((m, i) => {
          if (m.id == v) {
            if (m.creative.media_type === 'catalog' && m.creative.templateData) {
              m.creative.templateData.name = val.title;
            } else {
              m.creative.title = val.title;
            }
            this.$set(this.listData, i, m);
          }
        });
      });
      this.listData = JSON.parse(JSON.stringify(this.listData));
      this.setList();
      this.emitData();
    },
    getDiscriMsg(val) {
      if (JSON.stringify(this.discriMsg) == JSON.stringify(val)) return;
      this.currentSelect.map((v) => {
        this.listData.map((m, i) => {
          if (m.id == v) {
            if (m.creative.media_type === 'catalog' && m.creative.templateData) {
              m.creative.templateData.description = val.content;
            } else {
              m.creative.content = val.content;
            }
            this.$set(this.listData, i, m);
          }
        });
      });
      this.listData = JSON.parse(JSON.stringify(this.listData));
      this.setList();
      this.emitData();
    },
    getUrlMsg(val) {
      if (JSON.stringify(this.urlMsg) == JSON.stringify(val)) return;
      this.currentSelect.map((v) => {
        this.listData.map((m, i) => {
          if (m.id == v) {
            if (m.creative.media_type === 'catalog' && m.creative.templateData) {
              m.creative.templateData.link = val.web_url;
            } else {
              m.creative.web_url = val.web_url;
            }
            this.$set(this.listData, i, m);
          }
        });
      });
      this.listData = JSON.parse(JSON.stringify(this.listData));
      this.setList();
      this.emitData();
    },
    getDomainMsg(val) {
      if (JSON.stringify(this.domainMsg) == JSON.stringify(val)) return;
      this.currentSelect.map((v) => {
        this.listData.map((m, i) => {
          if (m.id == v) {
            m.conversion_domain = val.domain;
            this.$set(this.listData, i, m);
          }
        });
      });
      this.listData = JSON.parse(JSON.stringify(this.listData));
      this.setList();
      this.emitData();
    },
    getShowUrlMsg(val) {
      if (JSON.stringify(this.showUrlMsg) == JSON.stringify(val)) return;

      this.currentSelect.map((v) => {
        this.listData.map((m, i) => {
          if (m.id == v) {
            m.creative.show_url = val.show_url;
            this.$set(this.listData, i, m);
          }
        });
      });
      this.listData = JSON.parse(JSON.stringify(this.listData));
      this.setList();
      this.emitData();
    },
    getActionTypeMsg(val) {
      if (JSON.stringify(this.actionTypeMsg) == JSON.stringify(val)) return;
      this.currentSelect.map((v) => {
        this.listData.map((m, i) => {
          if (m.id == v) {
            if (m.creative.media_type === 'catalog' && m.creative.templateData) {
              m.creative.templateData.callToActionType = val.action_type;
            } else {
              m.creative.action_type = val.action_type;
            }
            this.$set(this.listData, i, m);
          }
        });
      });
      this.listData = JSON.parse(JSON.stringify(this.listData));
      this.setList();
      this.setActionTypeMsg();
      this.emitData();
    },
    getAdTypeMsg(val) {
      // if (JSON.stringify(this.adTypeMsg) == JSON.stringify(val)) return;
      this.currentSelect.map((v) => {
        this.listData.map((m, i) => {
          if (m.id == v) {
            let fbAssetFeedSpec = m.creative.fbAssetFeedSpec;
            // 保留原有的 action_type 和 web_url
            const originalActionType = m.creative.action_type;
            const originalWebUrl = m.creative.web_url;
            let creative = { ...m.creative, ...val };
            // 处理进阶创意
            if (val.isAdvancedCreative !== undefined) {
              creative.isAdvancedCreative = val.isAdvancedCreative;
            }
            if (val.media_type == 'catalog') {
              // 目录广告：回写 templateData、catalogAssetFeedSpec、advanced_material_enabled
              creative.media_type = 'catalog';
              if (val.templateData) {
                creative.templateData = { ...(m.creative.templateData || {}), ...val.templateData };
              }
              if (val.catalogAssetFeedSpec !== undefined) {
                creative.catalogAssetFeedSpec = val.catalogAssetFeedSpec;
              }
              if (val.advanced_material_enabled !== undefined) {
                creative.advanced_material_enabled = val.advanced_material_enabled;
              }
            } else if (val.media_type == 'asset_feed') {
              creative.media_type = 'asset_feed';
              creative.fbAssetFeedSpec = val.fbAssetFeedSpec ? { ...fbAssetFeedSpec, ...val.fbAssetFeedSpec } : null;
            } else if (val.isAdvancedCreative && val.fbAssetFeedSpec) {
              // 进阶创意时，保存fbAssetFeedSpec，同时保留原有的 actionTypes 和 linkUrls
              const originalActionTypes = fbAssetFeedSpec?.actionTypes || [];
              const originalLinkUrls = fbAssetFeedSpec?.linkUrls || [];
              creative.fbAssetFeedSpec = { ...fbAssetFeedSpec, ...val.fbAssetFeedSpec };
              // 如果新值没有 actionTypes 或为空，使用原有值
              if (!creative.fbAssetFeedSpec.actionTypes || creative.fbAssetFeedSpec.actionTypes.length === 0) {
                creative.fbAssetFeedSpec.actionTypes =
                  originalActionTypes.length > 0 ? originalActionTypes : originalActionType ? [originalActionType] : [];
              }
              // 如果新值没有 linkUrls 或为空，使用原有值
              if (
                !creative.fbAssetFeedSpec.linkUrls ||
                creative.fbAssetFeedSpec.linkUrls.length === 0 ||
                creative.fbAssetFeedSpec.linkUrls[0] === ''
              ) {
                creative.fbAssetFeedSpec.linkUrls =
                  originalLinkUrls.length > 0 && originalLinkUrls[0]
                    ? originalLinkUrls
                    : originalWebUrl
                    ? [originalWebUrl]
                    : [''];
              }
            } else {
              // 普通创意模式，保留原有的 action_type 和 web_url
              if (!creative.action_type && originalActionType) {
                creative.action_type = originalActionType;
              }
              if (!creative.web_url && originalWebUrl) {
                creative.web_url = originalWebUrl;
              }
              // 从进阶创意切换到普通创意时，尝试从 fbAssetFeedSpec 恢复数据
              if (fbAssetFeedSpec && !val.isAdvancedCreative) {
                if (!creative.action_type && fbAssetFeedSpec.actionTypes && fbAssetFeedSpec.actionTypes.length > 0) {
                  creative.action_type = fbAssetFeedSpec.actionTypes[0];
                }
                if (
                  !creative.web_url &&
                  fbAssetFeedSpec.linkUrls &&
                  fbAssetFeedSpec.linkUrls.length > 0 &&
                  fbAssetFeedSpec.linkUrls[0]
                ) {
                  creative.web_url = fbAssetFeedSpec.linkUrls[0];
                }
                // 同步素材数据
                if (creative.media_type === 'image' && fbAssetFeedSpec.imgList && fbAssetFeedSpec.imgList.length > 0) {
                  const firstImg = fbAssetFeedSpec.imgList[0];
                  if (!creative.image && firstImg.url) {
                    creative.image = firstImg.url;
                  }
                  if (!creative.source_id && firstImg.source_id) {
                    creative.source_id = firstImg.source_id;
                  }
                } else if (
                  creative.media_type === 'video' &&
                  fbAssetFeedSpec.videos &&
                  fbAssetFeedSpec.videos.length > 0
                ) {
                  const firstVideo = fbAssetFeedSpec.videos[0];
                  if (!creative.image && (firstVideo.url || firstVideo.source)) {
                    creative.image = firstVideo.url || firstVideo.source;
                  }
                  if (!creative.source_id && firstVideo.source_id) {
                    creative.source_id = firstVideo.source_id;
                  }
                  if (!creative.thumbUrl && firstVideo.thumbUrl) {
                    creative.thumbUrl = firstVideo.thumbUrl;
                  }
                  if (!creative.videoId && firstVideo.videoId) {
                    creative.videoId = firstVideo.videoId;
                  }
                  if (!creative.videoStatus && firstVideo.videoStatus) {
                    creative.videoStatus = firstVideo.videoStatus;
                  }
                }
              }
            }
            m.creative = JSON.parse(JSON.stringify(creative));
          }
        });
      });
      this.listData = JSON.parse(JSON.stringify(this.listData));

      this.setList();
      this.setAdTypeMsg();
      // 切换创意类型后，需要更新行动号召和推广链接的显示
      this.setActionTypeMsg();
      this.setUrlMsg();
      this.setAdvancedLinkUrlsMsg();
      this.setAdvancedActionTypesMsg();
      this.emitData();
      this.$nextTick(() => {
        this.getVideoStatus();
      });
    },
    // 处理进阶创意视频状态更新
    onAdvancedVideoStatusUpdate(data) {
      if (!data || !data.videos) return;
      // 更新当前选中广告的视频状态
      this.currentSelect.forEach((id) => {
        this.listData.forEach((item, index) => {
          if (item.id === id && item.creative.isAdvancedCreative && item.creative.fbAssetFeedSpec) {
            item.creative.fbAssetFeedSpec.videos = JSON.parse(JSON.stringify(data.videos));
            this.$set(this.listData, index, JSON.parse(JSON.stringify(item)));
          }
        });
      });
      this.setList();
      this.setAdTypeMsg();
      this.emitData();
    },
    setNameMsg() {
      this.nameMsg = this.isNotMix(this.nameList) ? this.nameList[0] : '';
    },
    getNameMsg(val) {
      if (JSON.stringify(this.nameMsg) == JSON.stringify(val)) return;
      this.currentSelect.map((v) => {
        this.listData.map((m, i) => {
          if (m.id == v) {
            m.name = val;
            this.$set(this.listData, i, m);
            this.$emit('setBaseName', 'ad', v, val);
          }
        });
      });
      this.listData = JSON.parse(JSON.stringify(this.listData));
      this.setList();
      this.emitData();
    },
    setStatusMsg() {
      this.statusMsg = this.isNotMix(this.statusList) ? this.statusList[0] : 'PAUSED';
    },
    getStatusMsg(val) {
      if (JSON.stringify(this.statusMsg) == JSON.stringify(val)) return;
      this.currentSelect.map((v) => {
        this.listData.map((m, i) => {
          if (m.id == v) {
            m.status = val;
            this.$set(this.listData, i, { ...m });
          }
        });
      });
      this.listData = JSON.parse(JSON.stringify(this.listData));
      this.setList();
      this.setStatusMsg();
      this.emitData();
    },
    getActionTypeListMsg(val) {
      // if(JSON.stringify(this.actionTypeListMsg) == JSON.stringify(val)) return;
      this.currentSelect.map((v) => {
        this.listData.map((m, i) => {
          if (m.id == v) {
            m.creative.fbAssetFeedSpec.actionTypes = val;
            this.$set(this.listData, i, m);
          }
        });
      });
      this.listData = JSON.parse(JSON.stringify(this.listData));
      this.setList();
      this.emitData();
    },
    getWebLinkListsMsg(val) {
      // if(JSON.stringify(this.webLinkListsMsg) == JSON.stringify(val)) return;
      this.currentSelect.map((v) => {
        this.listData.map((m, i) => {
          if (m.id == v) {
            m.creative.fbAssetFeedSpec.linkUrls = val;
            this.$set(this.listData, i, m);
          }
        });
      });
      this.listData = JSON.parse(JSON.stringify(this.listData));
      this.setList();
      this.emitData();
    },
    //接收混合参数
    setMixMsg(type, list) {
      if (!list) return;
      list.map((v) => {
        this.listData.map((k, i) => {
          if (v.id == k.id) {
            if (type == 'page') {
              k.creative.page_id = v.page_id;
              k.creative.instagram_actor_id = v.instagram_actor_id;
            }
            if (type == 'title') {
              k.creative.title = v.title;
            }
            if (type == 'content') {
              k.creative.content = v.content;
            }
            if (type == 'url') {
              k.creative.web_url = v.web_url;
            }
            if (type == 'showUrl') {
              k.creative.show_url = v.show_url;
            }
            if (type == 'actionType') {
              k.creative.action_type = v.action_type;
            }
            if (type == 'name') {
              k.name = v.name;
              //console.log('object--------------------------');
              this.$emit('setBaseName', 'ad', v.id, v.name);
              //console.log('===========================');
            }
            if (type == 'status') {
              k.status = v.status;
            }
            if (type == 'domain') {
              k.conversion_domain = v.domain;
            }
          }
          this.$set(this.listData, i, k);
        });
      });
      this.setList();
      this.emitData();
      if (type == 'page') this.setPageMsg();
      if (type == 'title') this.setTitleMsg();
      if (type == 'content') this.setDiscriMsg();
      if (type == 'url') this.setUrlMsg();
      if (type == 'showUrl') this.setShowUrlMsg();
      if (type == 'actionType') this.setActionTypeMsg();
      if (type == 'name') this.setNameMsg();
      if (type == 'status') this.setStatusMsg();
      if (type == 'domain') this.setDomainMsg();
    },
    setBaseData(type) {
      this.currentSelect.map((v) => {
        let list = this.baseData;
        let baseMsg = list.filter((k) => k.id == v) ? list.filter((k) => k.id == v)[0] : null;
        if (!baseMsg) {
          return;
        }
        let msg = JSON.parse(JSON.stringify(baseMsg));
        this.listData.map((m, i) => {
          if (m.id == v) {
            if (type == 'adType') {
              m.creative.media_type = msg.creative.media_type;
              m.creative.image = msg.creative.image;
              m.creative.source_id = msg.creative.source_id;
              m.creative.thumbUrl = msg.creative.thumbUrl;
              m.creative.mutiImgs =
                msg.mutiImgs && msg.creative.mutiImgs.length ? msg.creative.mutiImgs.filter((z) => z.image) : null;
              m.creative.post_id = msg.creative.post_id;
            } else if (type == 'actionsType') {
              m.creative.fbAssetFeedSpec.actionTypes = msg.creative.fbAssetFeedSpec.actionTypes;
            } else if (type == 'links') {
              m.creative.fbAssetFeedSpec.linkUrls = msg.creative.fbAssetFeedSpec.linkUrls;
            } else if (type == 'message') {
              m.creative.message = msg.creative.message;
            }
          }
          this.$set(this.listData, i, JSON.parse(JSON.stringify(m)));
        });
      });
      this.emitData();
      this.setList();
      if (type == 'adType') {
        this.setAdTypeMsg();
      } else if (type == 'message') {
        this.setMessageMsg();
      }
    },
    getVideoIds() {
      console.log(this.listData);
      console.log(this.updateList);
      let list = this.updateList.filter((v) => v.creative.media_type == 'video' && v.creative.videoStatus != 'ready');
      this.videoUploadId = list
        .map((k) => {
          return {
            videoId: k.creative.videoId,
            accountId: this.account,
            id: k.id,
          };
        })
        .filter((k) => k.videoId);
    },
    getVideoStatus() {
      this.getVideoIds();
      if (!this.videoUploadId.length) return;
      this.timer = null;
      // return
      console.log(this.cancleGetbatchVideoStatus);
      if (this.cancleGetbatchVideoStatus) return;
      querySlideshowVideoBatch(this.videoUploadId).then((res) => {
        console.log(res);
        res.data.forEach((items) => {
          if (items.videoStatus == 'ready') {
            this.setThumbList(items.videoId, items.thumbnails);
          }
          this.listData.forEach((item, index) => {
            if (items.videoId == item.creative.videoId) {
              item.creative.videoStatus = items.videoStatus;
              item.creative.media_type = 'video';
            }
            this.$set(this.listData, index, JSON.parse(JSON.stringify(item)));
          });
        });
        this.setList();
        this.setAdTypeMsg();
        this.emitData();
        this.$nextTick(() => {
          this.timer = setTimeout(() => {
            this.getVideoStatus();
          }, 10000);
        });
      });
    },
  },
  watch: {
    currentSelect: {
      handler() {
        this.isInitializing = true;
        this.setList();
        this.setMsg();
        this.$nextTick(() => {
          this.isInitializing = false;
        });
        //console.log(this.actionTypeMsg);
      },
      deep: true,
    },
    updateList: {
      handler() {
        this.listData = JSON.parse(JSON.stringify(this.updateList));
        // this.setList();
        // this.setMsg()
      },
      deep: true,
      immediate: true,
    },
    account: {
      handler() {
        this.getAccountPage();
      },
      immediate: true,
    },
    videoUploadId: {
      handler() {
        if (!this.timer) {
          // this.getVideoStatus();
        }
      },
      deep: true,
    },
    // 打开混合值弹窗时初始化编辑值
    messageMixShow: {
      handler(val) {
        if (val) {
          // 打开弹窗时，初始化为空数组，让用户输入新的统一值
          this.messageMixEditValue = [''];
        }
      },
    },
  },
  beforeDestroy() {
    if (this.queryTimer) {
      clearTimeout(this.queryTimer);
      this.queryTimer = null;
    }
  },
  created() {
    this.listData = JSON.parse(JSON.stringify(this.updateList));
    this.setList();
    this.setMsg();
  },
};
</script>
<style lang="scss" scope>
.targetingItem {
  margin-bottom: 10px;
  .baseName {
    display: flex;
    align-items: center;
    .lebel {
      flex: 140px 0 0;
      text-align: right;
      padding-right: 12px;
    }
  }
}
.dpa-variable-tags {
  margin-top: 6px;
  .dpa-variable-label {
    font-size: 12px;
    color: #909399;
    margin-right: 4px;
  }
  .el-tag {
    cursor: pointer;
    &:hover {
      background-color: #ecf5ff;
      border-color: #409eff;
      color: #409eff;
    }
  }
}
</style>
